var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "cog-checkable cog-input cog-checkable--inline",
      class: { "is-read-only": _vm.readonly }
    },
    [
      _vm.readonly
        ? _c("div", [_vm._v(_vm._s(_vm.displayValue || " "))])
        : _c(
            "el-checkbox",
            _vm._b(
              {
                attrs: { label: _vm.label },
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.internalValue,
                  callback: function($$v) {
                    _vm.internalValue = $$v
                  },
                  expression: "internalValue"
                }
              },
              "el-checkbox",
              _vm.$attrs,
              false
            ),
            [_vm._v("\n\t\t" + _vm._s(_vm.label) + "\n\t")]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }